import React, { type Dispatch, type SetStateAction } from 'react';
import { Form } from 'react-bootstrap-5';

import Emails from './emails';
import PhoneNumbers from './phone_numbers';
import Addresses from './addresses';
import type { ContactAddress, ContactEmail, ContactPhoneNumber } from 'bundles/connect/types';

type CompanyFormProps = {
  addresses: ContactAddress[];
  emails: ContactEmail[];
  formData: {
    name?: string;
    website?: string;
    description?: string;
  };
  phoneNumbers: ContactPhoneNumber[];
  onFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSetAddresses: Dispatch<React.SetStateAction<ContactAddress[]>>;
  onSetEmails: Dispatch<SetStateAction<ContactEmail[]>>;
  onSetPhoneNumbers: Dispatch<SetStateAction<ContactPhoneNumber[]>>;
}

export default function CompanyForm({
  formData,
  addresses,
  emails,
  phoneNumbers,
  onFormChange,
  onSetAddresses,
  onSetEmails,
  onSetPhoneNumbers
}: CompanyFormProps) {
  return (
    <>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control name="name" value={formData.name || ''} onChange={onFormChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Website</Form.Label>
        <Form.Control name="website" value={formData.website || ''} onChange={onFormChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Description</Form.Label>
        <Form.Control as="textarea" name="description" value={formData.description || ''} onChange={onFormChange}/>
      </Form.Group>
      <Emails
        emails={emails}
        onSet={onSetEmails}
      />
      <PhoneNumbers
        phoneNumbers={phoneNumbers}
        onSet={onSetPhoneNumbers}
      />
      <Addresses
        addresses={addresses}
        onSet={onSetAddresses}
      />
    </>
  );
}
